import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { bindActionCreators, compose } from 'redux'

import { _route } from 'routes/config'
import { listenChild } from 'services/patient'
import * as PatientsActions from 'store/patients/actions'
import { ChildListenerContext, IChildListenerContext } from './context'

export const withChildListener = (WrappedComponent: React.ElementType) => {
  interface IReduxProps {
    PatientsLib: any
  }
  interface IProps extends RouteComponentProps<{ id: string }>, IReduxProps {}

  const HOC: React.FC<IProps> = props => {
    const onChildChange = (child: any) => {
      props.PatientsLib.setChild(child)
    }

    const { childListener, setChildListener } = React.useContext<
      IChildListenerContext
    >(ChildListenerContext)

    React.useEffect(() => {
      if (childListener === null) {
        const listenerOffFuncRef = listenChild(
          props.match.params.id,
          onChildChange,
          // redirect to children list page if childId is inappropriate or user doesn't have the permission
          err => {
            console.log(err)
            props.history.push(_route.child.list)
          }
        )

        setChildListener(() => listenerOffFuncRef)
      }
    }, [])

    return <WrappedComponent {...props} childListener={childListener} />
  }

  const withHOCs = compose(withRouter)(HOC)

  const mapDispatchToProps = dispatch => ({
    PatientsLib: bindActionCreators(PatientsActions, dispatch)
  })

  const Connected = connect(null, mapDispatchToProps)(withHOCs)

  return props => <Connected {...props} />
}



// WEBPACK FOOTER //
// ./src/components/ChildListener/withChildListener.tsx